function prepareRenderList(clientAuthorizedAccounts) {
    const sortedCaaList = clientAuthorizedAccounts.sort((caa1, caa2) => {
        if (
            caa1 &&
            caa1.account &&
            caa1.account.name &&
            caa2 &&
            caa2.account &&
            caa2.account.name
        ) {
            return caa1.account.name.localeCompare(caa2.account.name);
        }
        return false;
    });

    const revokedCaaList = sortedCaaList.filter(caa => caa.revoked);

    const activeCaaList = sortedCaaList.filter(caa => !caa.revoked);

    const newSortedCaaList = [...revokedCaaList, ...activeCaaList];

    return newSortedCaaList;
}
export default prepareRenderList;
